<template>
 <div class="block-orientation d-flex flex-wrap">
    <div class="block-orientation__orientation-btn mr-4 mt-2 px-2 d-flex align-items-center justify-content-center" v-for="orientation in data"
      :key="orientation" @click="selectOrientation(orientation)"
      :class="{selected: selectedOrientation === orientation}">
      {{orientations[orientation]}}
    </div>
  </div>
</template>
<script>

export default {
  name: 'CalculatePriceBlockOrientation',
  props: {
    data: {
      default: () => {
        return []
      }
    }
  },
  data: () => {
    return {
      selectedOrientation: '',
      orientations: { long: 'По длинной стороне', short: 'По короткой стороне' }
    }
  },
  methods: {
    selectOrientation (orientation) {
      if (orientation === this.selectedOrientation) {
        this.selectedOrientation = ''
      } else {
        this.selectedOrientation = orientation
      }
      this.$emit('selectOrientation', this.selectedOrientation)
    }
  }
}
</script>

<style lang="scss" scoped>
.block-orientation {
  &__orientation-btn {
    cursor: pointer;
    position: relative;
    height: 38px;
    min-width: 80px;
    border-radius: 4px;
    box-shadow: inset 0 1px 0 rgba(40, 189, 139, 0.15);
    background-color: #e9f8f3;
    color: #28bd8b;
    max-width: 400px;

    &.selected {
      background-color: #28bd8b;
      color: #fff;
    }
  }
}
</style>
